module.exports = __webpack_public_path__ + "img/title.ba4b880b.png";